export const SITE = {
  brand: "BackHome Restoration Inc.",
  brandShort: "BackHome",
  phone: "416-828-2127",
  phoneHref: "tel:+14168282127",
  email: "claims@backhomerestoration.com",
  emailHref: "mailto:claims@backhomerestoration.com",
  hrEmail: "hr@backhomerestoration.com",
  hrEmailHref: "mailto:hr@backhomerestoration.com",
  tagline: "24/7 Emergency Restoration & Contents Services",
  region: "Toronto & the GTA",
  // Optional looping hero clip (mp4/webm URL). Leave null to use the animated photo (rain + lightning).
  heroVideo: null,
  serviceAreas: [
    "Toronto", "Mississauga", "Brampton", "Vaughan", "Markham",
    "Richmond Hill", "Ajax", "Pickering", "Whitby", "Oshawa",
    "Burlington", "Oakville",
  ],
};

// "From flood to home" scroll story (Home page). Copy + stats are editable here.
export const RESTORATION_STORY = [
  {
    n: "01",
    key: "emergency",
    title: "Emergency",
    desc: "The call comes in at any hour. Water is rising and every minute it sits, damage spreads. A live coordinator answers and a crew is dispatched immediately.",
    stat: "60 min",
    statLabel: "GTA response target",
    img: "/brand/photo_stage1_emergency.jpg",
  },
  {
    n: "02",
    key: "extraction",
    title: "Water Extraction",
    desc: "Truck-mounted pumps and extractors pull standing water out fast, stopping the spread before it reaches framing, subfloor and contents.",
    stat: "Hours 1–6",
    statLabel: "Standing water removed",
    img: "/brand/photo_stage2_extraction.jpg",
  },
  {
    n: "03",
    key: "drying",
    title: "Drying & Dehumidification",
    desc: "Industrial air movers and dehumidifiers run around the clock while moisture readings are logged daily until the structure hits dry standard.",
    stat: "24–72 h",
    statLabel: "Structural drying",
    img: "/brand/photo_stage3_drying.jpg",
  },
  {
    n: "04",
    key: "cleaning",
    title: "Cleaning & Sanitization",
    desc: "Damaged materials come out. Surfaces are cleaned, disinfected and treated against mold and odour. Contents are inventoried and packed out.",
    stat: "Days 3–7",
    statLabel: "Sanitized & cleared",
    img: "/brand/photo_stage4_cleaning.jpg",
  },
  {
    n: "05",
    key: "backhome",
    title: "Back Home",
    desc: "Repairs wrap, contents are packed back and placed exactly where they belong. The lights come on. The house is a home again.",
    stat: "Final step",
    statLabel: "Pack-back & closeout",
    img: "/brand/photo_stage5_backhome.jpg",
  },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/team", label: "Team" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

// Curated emergency-restoration & contents-services imagery.
// Brand-owned images (AI-generated scenes and real team headshots) live in
// `frontend/public/` so they travel with the React build and survive
// production deployments. Generic placeholders fall back to Unsplash.
const ASSET = process.env.PUBLIC_URL || "";

export const IMG = {
  hero:              `${ASSET}/brand/hero_flood_canada.jpg`,            // Canadian suburban home flooded
  contentsAssessment:`${ASSET}/brand/service_contents_assessment.jpg`,  // Clipboard + inventory tags + camera
  packout:           `${ASSET}/brand/service_packout.jpg`,              // Labeled boxes in a demoed hallway
  packback:          `${ASSET}/brand/service_packback.jpg`,             // Restored room with sealed boxes
  emergencyOps:      `${ASSET}/brand/service_emergency.jpg`,            // Air movers + dehumidifier on a flooded floor
  storage:           `${ASSET}/brand/service_storage.jpg`,              // Clean warehouse with wrapped contents
  movingTruck:       `${ASSET}/brand/service_moving.jpg`,               // Open moving truck with wrapped furniture
  aboutFire:         `${ASSET}/brand/about_fire_damage.jpg`,            // Fire-damaged interior with smoke and embers

  // Cinematic home-page chapters (photoreal, AI-generated; vehicles carry the BackHome logo)
  contentsPackout:   `${ASSET}/brand/photo_contents_packout.jpg`,       // Technician wrapping a framed photo
  iceStorm:          `${ASSET}/brand/photo_ice_storm_street.jpg`,       // GTA street in an ice storm, BackHome van
  torontoBlueHour:   `${ASSET}/brand/photo_toronto_bluehour.jpg`,       // Aerial Toronto skyline at blue hour
  stageDrying:       `${ASSET}/brand/photo_stage3_drying.jpg`,
  stageBackHome:     `${ASSET}/brand/photo_stage5_backhome.jpg`,
  stageFlood:        `${ASSET}/brand/photo_stage1_emergency.jpg`,
  crewTruck:         `${ASSET}/brand/photo_crew_truck.jpg`,              // Crew loading a BackHome truck at dusk
  warehouseContents: `${ASSET}/brand/photo_warehouse_contents.jpg`,      // Climate-controlled contents warehouse

  teamJulio:    `${ASSET}/team/julio.jpg`,
  teamJesus:    `${ASSET}/team/jesus.jpg`,
  teamCarolina: `${ASSET}/team/carolina.jpg`,

  about:      "https://images.unsplash.com/photo-1574359411659-15573a27fd0c?auto=format&fit=crop&w=1600&q=80",
  warehouse:  "https://images.unsplash.com/photo-1565008576549-57569a49371d?auto=format&fit=crop&w=1600&q=80",
  moving:     "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?auto=format&fit=crop&w=1600&q=80",
  packing:    "https://images.unsplash.com/photo-1606820854416-439b3305ff39?auto=format&fit=crop&w=1600&q=80",
  inspection: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=80",
  toronto:    "https://images.unsplash.com/photo-1542621334-a254cf47733d?auto=format&fit=crop&w=2000&q=80",
  water:      "https://images.unsplash.com/photo-1534862262637-373c120dcbcc?auto=format&fit=crop&w=1600&q=80",
  team:       "https://images.unsplash.com/photo-1607400201515-c2c41c07d307?auto=format&fit=crop&w=1600&q=80",
  contact:    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=2000&q=80",
  proj1:      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1400&q=80",
  proj2:      "https://images.unsplash.com/photo-1571838772298-539aea8a8cf2?auto=format&fit=crop&w=1400&q=80",
  proj3:      "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?auto=format&fit=crop&w=1400&q=80",
  proj4:      "https://images.unsplash.com/photo-1565182999561-18d7dc61c393?auto=format&fit=crop&w=1400&q=80",
  proj5:      "https://images.unsplash.com/photo-1534344974380-cb1cfd323f5d?auto=format&fit=crop&w=2000&q=80",
  proj6:      "https://images.unsplash.com/photo-1502672023488-70e25813eb80?auto=format&fit=crop&w=1400&q=80",
};
